import React from 'react'
import { bg } from 'portal/assets/images'

export default function Banner() {
  return(
    <div>
      <img src={ bg } alt="" style={{ width: '100%', height: 380 }} />
    </div>
  )
}
